import { type Dispatch, type FC, type SetStateAction } from "react";
import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import { ClientImageLibraryModal } from "@clientFrontend/features/publication/components/ClientImageLibraryModal";
import { type ClientImage } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/type";
import { type DisplayVariant } from "./types";
import { SingleSelectFooter } from "./uiParts/SingleSelectFooter";
import * as styles from "./styles.css";

type Props = {
  hiddenFieldName: string;
  clientImageUrl: string;
  headerTitle?: string;
  errorMessages: string[];
  selectedImage: ClientImage | null;
  // 選択画像(または未選択時のダミー)の表示URL。バリアント解決はコンテナーが担う
  displayImageUrl: string;
  // プレビュー幅の出し分けに使う(square=158px / original=280px)
  displayVariant: DisplayVariant;
  showModal: boolean;
  clientImages: ClientImage[];
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  fetchClientImages: () => void;
  setClientImages: Dispatch<SetStateAction<ClientImage[]>>;
  handleConfirm: (selectedImages: ClientImage[]) => void;
};

export const Presentation: FC<Props> = ({
  hiddenFieldName,
  clientImageUrl,
  headerTitle,
  errorMessages,
  selectedImage,
  displayImageUrl,
  displayVariant,
  showModal,
  clientImages,
  handleOpenModal,
  handleCloseModal,
  fetchClientImages,
  setClientImages,
  handleConfirm,
}) => {
  return (
    <div className={styles.wrapper}>
      {errorMessages.map((message) => (
        <div key={message} className={styles.errorText}>
          <Icon name="attention" />
          <span className={styles.errorTextSpace}>{message}</span>
        </div>
      ))}
      <div className={styles.imageArea}>
        {/* サーバー送信用の hidden field。選択画像の id を反映する(未選択は空= 画像解除) */}
        <input type="hidden" name={hiddenFieldName} value={selectedImage?.id ?? ""} />
        <img
          className={styles.thumbnail[displayVariant]}
          src={displayImageUrl}
          width={styles.previewSize[displayVariant].width}
          height={styles.previewSize[displayVariant].height}
          alt={selectedImage ? "設定中の画像" : "画像未設定"}
        />
        <Button
          onClick={handleOpenModal}
          theme="secondary"
          className={styles.selectButton}
          leftIcon={<Icon name="picture" />}
        >
          画像の設定
        </Button>
      </div>
      {showModal && (
        <ClientImageLibraryModal
          mode="single"
          maxCount={1}
          clientImageUrl={clientImageUrl}
          headerTitle={headerTitle}
          initialSelectedImages={selectedImage ? [selectedImage] : []}
          clientImages={clientImages}
          fetchClientImages={fetchClientImages}
          setClientImages={setClientImages}
          onConfirm={handleConfirm}
          onClose={handleCloseModal}
          renderFooter={({ onConfirm }) => (
            <SingleSelectFooter buttonProps={{ onClick: onConfirm }} />
          )}
        />
      )}
    </div>
  );
};
